import { ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { InboxUrlFlag, URL_FLAG_ON } from './inbox.constants';

/** Keeps a loading boolean true for at least `ms` ms after it goes false, avoiding jitter. */
export function nicerLoading(loading$: Observable<boolean>, ms = 350): Observable<boolean> {
  return loading$.pipe(
    switchMap((loading) => loading ? of(true) : of(false).pipe(delay(ms))),
    distinctUntilChanged(),
  );
}

/**
 * check if the window view port reach out the max width query
 * @return {boolean}
 */
export function isMobile(): boolean {
  return window.matchMedia('(max-width:600px)').matches;
}

export function isUrlFlagOn(params: ParamMap, name: InboxUrlFlag): boolean {
  return params.get(name) === URL_FLAG_ON;
}

/** Null rather than false, because Angular's router drops a null query param instead of writing `=false`. */
export function buildUrlFlag(on: boolean): typeof URL_FLAG_ON | null {
  return on ? URL_FLAG_ON : null;
}
